import { createAction } from 'redux-actions';

import { openMobileOverlay } from 'shared/utils/open-overlay';


export const OPEN_SUBSCRIBE_OVERLAY = 'OPEN.SUBSCRIBE-OVERLAY';
const OPEN_SUBSCRIBE_OVERLAY_ACTION = createAction(OPEN_SUBSCRIBE_OVERLAY);

export const OPEN_BUY_VIDEO_OVERLAY = 'OPEN.BUY-VIDEO-OVERLAY';
const OPEN_BUY_VIDEO_OVERLAY_ACTION = createAction(OPEN_BUY_VIDEO_OVERLAY);


export function openSubscribeOverlay() {
  return function (dispatch) {
    dispatch(OPEN_SUBSCRIBE_OVERLAY_ACTION());

    return openMobileOverlay('#/channel/subscribe');
  };
}

export function openBuyVideoOverlay(videoId) {
  return function (dispatch) {
    dispatch(OPEN_BUY_VIDEO_OVERLAY_ACTION());

    return openMobileOverlay(`#/video/${videoId}/purchase`);
  };
}



// WEBPACK FOOTER //
// ./src/widget/redux/client/actions/mobile-overlay-openners/payment-pages-actions.js